export default "__VITE_ASSET__ed19a893__"